import React from "react"
import * as classes from "./Card.module.css"

export const Card = ({
  children,
  styles,
}: {
  children: JSX.Element
  styles: React.CSSProperties
}) => (
  <div className={classes.card} style={styles}>
    {children}
  </div>
)
